module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 animatedParent",
    attrs: {
      "role": "main"
    }
  }, [_vm._m(0), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated xFadeInDown",
    attrs: {
      "data-id": "1"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1357.9790879026448!2d18.65502108491149!3d49.663751411554756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDnCsDM5JzQ5LjUiTiAxOMKwMzknMjEuMyJF!5e1!3m2!1sen!2scz!4v1541969210347",
      "width": "100%",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fecc47d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterMap.vue
// module id = 1214
// module chunks = 1